var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithubLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1048 16V13C11.213 12.0605 10.9338 11.1176 10.3275 10.375C12.6594 10.375 14.9913 8.875 14.9913 6.25C15.0535 5.3125 14.7814 4.39 14.214 3.625C14.4316 2.7625 14.4316 1.8625 14.214 1C14.214 1 13.4367 1 11.8821 2.125C9.83007 1.75 7.71583 1.75 5.66378 2.125C4.1092 1 3.33191 1 3.33191 1C3.09872 1.8625 3.09872 2.7625 3.33191 3.625C2.76594 4.38691 2.49124 5.31459 2.55461 6.25C2.55461 8.875 4.88649 10.375 7.21837 10.375C6.91522 10.7425 6.68981 11.1625 6.55767 11.6125C6.42553 12.0625 6.38666 12.535 6.44108 13M6.44108 13V16M6.44108 13C2.93549 14.5 2.55458 11.5 1 11.5",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubLogo);
export default __webpack_public_path__ + "static/media/githubLogo.9775477f03bf88459f5d75fbaa387538.svg";
export { ForwardRef as ReactComponent };